import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from '../../hooks';
import { PlatformIcon, ArrowRight } from '../common/Icons';
import { platformsData } from '../../data/platforms';

const HeroSection = () => {
  const [ref, isInView] = useInView(0.1);

  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center relative african-pattern"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black" />

      <div
        ref={ref}
        className={`relative z-10 max-w-7xl mx-auto px-6 pt-20 text-center transition-all duration-1000 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <p className="text-primary-500 font-medium tracking-widest mb-4 text-sm md:text-base">
          🌍 PROUDLY TANZANIAN • PROUDLY AFRICAN
        </p>

        <h1 className="font-gaming text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-black mb-6 leading-none">
          <span className="text-gradient animate-glitch">RIVEN</span>
          <br />
          <span className="text-white glow-teal">BYTE</span>
        </h1>

        <p className="text-xl md:text-2xl lg:text-3xl text-gray-300 max-w-3xl mx-auto mb-8 font-light">
          Crafting{' '}
          <span className="text-primary-500 font-semibold">
            legendary African gaming experiences
          </span>{' '}
          from the heart of Tanzania to the world
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <Link
            to="/games"
            className="group btn-primary flex items-center gap-3"
          >
            <span>EXPLORE GAMES</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
          <button className="btn-secondary">WATCH TRAILER</button>
        </div>

        {/* Platform Icons */}
        <div className="flex flex-wrap justify-center gap-6 text-gray-400">
          {platformsData.slice(0, 7).map((platform) => (
            <div
              key={platform.id}
              className="hover:text-primary-400 transition-colors cursor-pointer"
              title={platform.name}
            >
              <PlatformIcon platform={platform.id} />
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce-slow">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-primary-500 rounded-full mt-2 animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
